
export default function TermsOfUse() {
  return (
    <div>
      <h1>Terms of Use</h1>
    </div>
  );
}
